import { isFeatureEnabled } from 'owa-feature-flags';
import { getCurrentFilters } from '../selectors/getCurrentFilters';
import { CalendarEventsFilters } from './CalendarEventsFilters';

export function getDefaultCurrentFilters(): (CalendarEventsFilters | string)[] {
    if (!isFeatureEnabled('cal-eventsFilterMenu')) {
        return [CalendarEventsFilters.All];
    }
    return getCurrentFilters();
}
